const formatDate = (date: string | number, options: Intl.DateTimeFormatOptions): string => {
  const d = typeof date === "number"
    ? new Date(date * 1000)
    : new Date(date.includes("T") ? date : `${date}T00:00:00`);
  return d.toLocaleDateString(navigator.language, options);
};

export default formatDate;
